module.exports = __webpack_public_path__ + "img/shandong_qilu_ertong.1426a057.png";